import request from 'api/requestUtils'
import config from 'constants/config'
import { Job, JobDetailsResponse, JobPostingResponse } from './types'
import { cleanHtmlText } from 'lib/utils/cleanHtml'

const baseUrl = config.SMARTRECRUITERS_API_BASE_URL

async function getJobDetails(id: string): Promise<JobDetailsResponse> {
  const response = await request.get<JobDetailsResponse>(
    `/postings/${id}`,
    {},
    baseUrl,
  )

  return response
}

export async function getJobPostings(): Promise<Array<Job>> {
  const { content } = await request.get<{ content: Array<JobPostingResponse> }>(
    '/postings',
    {},
    baseUrl,
  )

  if (content.length === 0) {
    return []
  }
  const fetchJobDetailsPromises = content.map(async(job): Promise<Job> => {
    const details = await getJobDetails(job.id)
    return {
      id: job.id,
      title: job.name,
      department: job.department?.label || '',
      location: job.location?.city || '',
      date: job.releasedDate,
      description: cleanHtmlText(details.jobAd.sections.jobDescription.text || ''),
      employmentType: job.typeOfEmployment?.label || '',
      applyUrl: details?.postingUrl || '',
    }
  })

  const results = await Promise.allSettled(fetchJobDetailsPromises)

  const successfulJobs = results
    .filter((result): result is PromiseFulfilledResult<Job> => result.status === 'fulfilled')
    .map(result => result.value)

  return successfulJobs
}
